export default "__VITE_ASSET__Cy0brsQ___"